import { render, staticRenderFns } from "./UiCheckbox.vue?vue&type=template&id=45aa962c&"
import script from "./UiCheckbox.vue?vue&type=script&lang=js&"
export * from "./UiCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports